export function TickIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.6668 7.38667V8C14.666 9.43761 14.2005 10.8364 13.3397 11.9879C12.4789 13.1393 11.269 13.9817 9.8904 14.3893C8.51178 14.7969 7.03834 14.7479 5.68981 14.2497C4.34128 13.7515 3.18993 12.8307 2.40747 11.6247C1.62501 10.4187 1.25336 8.99204 1.34795 7.55754C1.44254 6.12304 1.9983 4.75755 2.93235 3.66471C3.8664 2.57188 5.12869 1.81025 6.53096 1.49343C7.93323 1.17661 9.40034 1.32156 10.7135 1.90667M14.6668 2.66667L8.00017 9.34L6.00017 7.34" stroke="#5D9298" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
